import React from "react";
import { useAppDispatch } from "index";

import { Button, Menu, MenuItem, Stack, Typography } from "@mui/material";

import { ParsedExport } from "@store/data/types";
import useLanguageHook from "../hooks/useLanguageHook";
import { MoreVert as MoreVertIcon, Delete, Edit as EditIcon } from "@mui/icons-material";
import { removeData } from "@store/data/actions";

function DataExportMenu({ selectedExport, onRename }: { selectedExport: ParsedExport; onRename: () => void }) {
  const [anchorElement, setAnchorElement] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorElement);
  const dispatch = useAppDispatch();
  const { t } = useLanguageHook();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElement(event.currentTarget);
  };

  const handleClose = (action?: () => void) => () => {
    action?.();
    setAnchorElement(null);
  };

  return (
    <>
      <Button
        size="small"
        onClick={handleClick}
        sx={{
          minWidth: 40,
          height: 64,
        }}
      >
        <MoreVertIcon />
      </Button>
      <Menu anchorEl={anchorElement} open={open} onClose={handleClose()}>
        <MenuItem
          onClick={handleClose(() => {
            onRename();
          })}
        >
          <Stack direction="row" gap={2}>
            <EditIcon />
            <Typography variant="h6">{t.DataPage.RenameExport}</Typography>
          </Stack>
        </MenuItem>
        <MenuItem
          onClick={handleClose(() => {
            dispatch(removeData(selectedExport.id));
          })}
        >
          <Stack direction="row" gap={2}>
            <Delete />
            <Typography variant="h6">{t.DataPage.DeleteExport}</Typography>
          </Stack>
        </MenuItem>
      </Menu>
    </>
  );
}

export default DataExportMenu;
